import { render, staticRenderFns } from "./createGallery.vue?vue&type=template&id=03fb2372&scoped=true&"
import script from "./createGallery.vue?vue&type=script&lang=js&"
export * from "./createGallery.vue?vue&type=script&lang=js&"
import style0 from "./createGallery.vue?vue&type=style&index=0&id=03fb2372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb2372",
  null
  
)

export default component.exports